<div class="row">
  <div class="col-sm-12 col-lg-4 form-group">
    <input type="text" placeholder="Fecha de Inicio" class="form-control" bsDatepicker
      [bsConfig]="{ adaptivePosition: true, dateInputFormat: 'DD/MM/YYYY' }" [(bsValue)]="fechaInicio">
  </div>
  <div class="col-sm-12 col-lg-4 form-group">
    <input type="text" placeholder="Fecha Fin" class="form-control" bsDatepicker
      [bsConfig]="{ adaptivePosition: true, dateInputFormat: 'DD/MM/YYYY' }" [(bsValue)]="fechaFin"
      [minDate]="fechaInicio">
  </div>
  <div class="col-sm-12 col-lg-4 d-flex justify-content-start align-items-end">
    <button type="button" class="btn btn-outline-primary d-flex align-items-center mb-4" (click)="ObtenerCheques()">
      <span class="material-icons">search</span>
      Buscar
    </button>
  </div>
  <div class="col-12">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th scope="col" class="text-uppercase text-left">Fecha de Ingreso</th>
            <th scope="col" class="text-uppercase text-center">Banco emisor</th>
            <th scope="col" class="text-uppercase text-center">Documento</th>
            <th scope="col" class="text-uppercase text-center">Transacción</th>
            <th scope="col" class="text-uppercase text-right">Valor</th>
            <th scope="col" class="text-uppercase text-left">Fecha de la Máquina</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="cheques?.length === 0">
            <td colspan="5" class="text-uppercase text-center">No hay información para mostrar</td>
          </tr>
          <tr *ngFor="let cheque of cheques">
            <td class="text-left">{{cheque?.fechaIngreso | date: 'dd/MM/yyyy'}}</td>
            <td class="text-center">{{cheque?.bancoEmisor}}</td>
            <td class="text-center">{{cheque?.documento}}</td>
            <td class="text-center">{{cheque?.transaccion}}</td>
            <td class="text-right">{{cheque?.valor | currency}}</td>
            <td class="text-left">{{cheque?.fechaMaquinaIngreso }}</td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-between p-2">
        <ngb-pagination [collectionSize]="cantidad" [(page)]="pagina" [pageSize]="paginaTamanio" [rotate]="true"
          [maxSize]="5" [boundaryLinks]="true" (pageChange)="ObtenerCheques()">
        </ngb-pagination>

        <select class="custom-select" style="width: auto" [(ngModel)]="paginaTamanio"
          (ngModelChange)="ObtenerCheques()">
          <option [ngValue]="3">3 cheques por página</option>
          <option [ngValue]="5">5 cheques por página</option>
          <option [ngValue]="10">10 cheques por página</option>
        </select>
      </div>
    </div>
  </div>
</div>
